<template>
  <div style="margin-top: 20px">
    <div
      style="
        display: flex;
        font-size: 28px;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid black;
        background-color: #f7f7f7;
      ">
      <div :class="getDetailActive == 1 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 1"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'">
          需求方信息
        </div>
      </div>
      <div :class="getDetailActive == 2 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 2"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'">
          需求项目信息
        </div>
      </div>
      <div :class="getDetailActive == 3 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 3"
          :class="getDetailActive == 3 ? 'getDetail' : 'getdetail'">
          图片展示
        </div>
      </div>
      <div :class="getDetailActive == 4 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 4"
          :class="getDetailActive == 4 ? 'getDetail' : 'getdetail'">
          竞价须知
        </div>
      </div>
      <div :class="getDetailActive == 5 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 5"
          :class="getDetailActive == 5 ? 'getDetail' : 'getdetail'">
          交易公告
        </div>
      </div>
    </div>
    <div
      style="
        text-align: center;
        padding: 20px;
        padding-top: 40px;
        font-size: 24px;
      "
      class="conent">
      <div v-show="getDetailActive == 1">
        <div>
          <div class="fengexian">
            <el-divider content-position="center">需求方信息</el-divider>
          </div>
        </div>
        <div style="display: flex">
          <div class="left" style="width: 50%; text-align: left">
            <div class="tet">
              <div class="tet1">需求方类型:</div>
              <div class="tet2">
                <span>{{
                  getDictsVal(dicts.companyList, projectDetail.company)
                }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">电话:</div>
              <div class="tet2">
                <span>{{ realPhone || projectDetail.phone }}</span>
                <img
                  src="../assets/img/openEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  @click="checkShowPhone" />
              </div>
            </div>
            <div class="tet">
              <div class="tet1">联系人证件号码:</div>
              <div class="tet2">
                <span>{{ projectDetail.idnum }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.company == 3">
              <div class="tet1">公司类型:</div>
              <div class="tet2">
                <span>{{
                  getDictsVal(dicts.companyTypeList, projectDetail.companyType)
                }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.company == 3">
              <div class="tet1">注册证号:</div>
              <div class="tet2">
                <span>{{ projectDetail.registerNo || '/' }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.company == 3">
              <div class="tet1">注册资本(万元):</div>
              <div class="tet2">
                <span>{{ projectDetail.registerAmount || '/' }}</span>
              </div>
            </div>
          </div>
          <div class="left" style="width: 50%; text-align: left">
            <div class="tet">
              <div class="tet1">名称:</div>
              <div class="tet2">
                <span>{{ projectDetail.needname || '/' }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">联系地址:</div>
              <div class="tet2">
                <span>{{ projectDetail.address || '/' }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.company == 3">
              <div class="tet1">公司名称:</div>
              <div class="tet2">
                <span>{{ projectDetail.companyName || '/' }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.company == 3">
              <div class="tet1">法定代表人:</div>
              <div class="tet2">
                <span>{{ projectDetail.legalperson || '/' }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.company == 3">
              <div class="tet1">邮箱:</div>
              <div class="tet2">
                <span>{{ projectDetail.email || '/' }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">标的类型:</div>
              <div class="tet2">
                <span>{{ projectDetail.subType || '/' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="border: 1px solid #fff" v-show="getDetailActive == 2">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">需求项目信息</el-divider>
          </div>
        </div>
        <div style="display: flex">
          <div class="left" style="width: 50%; text-align: left">
            <!-- <div class="tet">
              <div class="tet1">位置区域:</div>
              <div class="tet2">
                <span>{{ projectDetail.areaName || "/" }}</span>
              </div>
            </div> -->
            <div class="tet">
              <div class="tet1">数量:</div>
              <div class="tet3">
                <span>{{ projectDetail.area || '/' }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">承受价格:</div>
              <div class="tet3">
                <span>{{
                  projectDetail.price + '元/' + projectDetail.unit || '/'
                }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.transType != 2">
              <div class="tet1">流转需求起始日期:</div>
              <div class="tet3">
                <span>{{ projectDetail.needstarttime || '/' }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">项目类型:</div>
              <div class="tet3">
                <span>{{
                  getClassList(classTypeList, projectDetail.number)
                }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">地块应具备条件:</div>
              <div class="tet3">
                <span>{{ projectDetail.condition || '/' }}</span>
              </div>
            </div>
          </div>
          <div class="left" style="width: 50%; text-align: left">
            <div class="tet">
              <div class="tet1">项目名称:</div>
              <div class="tet2">
                <span>{{ projectDetail.projectname || '/' }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">数量单位:</div>
              <div class="tet2">
                <span>{{ projectDetail.unit }}</span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.transType != 2">
              <div class="tet1">需求年限（年）:</div>
              <div class="tet3">
                <span>{{ getYearLimit() }} </span>
              </div>
            </div>
            <div class="tet" v-if="projectDetail.transType != 2">
              <div class="tet1">流转需求终止日期:</div>
              <div class="tet3">
                <span>{{ projectDetail.needstoptime || '/' }}</span>
              </div>
            </div>
            <div class="tet">
              <div class="tet1">转入用途:</div>
              <div class="tet3">
                <span>{{ projectDetail.description || '/' }}</span>
              </div>
            </div>
            <!-- <div class="tet">
              <div class="tet1">交易方式:</div>
              <div class="tet3">
                <span>{{
                  getDictsVal(dicts.transTypeList, projectDetail.transType)
                }}</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div v-show="getDetailActive == 3">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">图片展示</el-divider>
          </div>
        </div>
        <div class="imgcontent">
          <el-image
            v-for="(item, index) in projectDetail.imgList"
            :key="index"
            style="
              width: 48%;
              height: auto;
              margin-left: 10px;
              margin-bottom: 10px;
            "
            :src="item"
            :preview-src-list="projectDetail.imgList">
          </el-image>
        </div>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">报名须知</el-divider>
          </div>
        </div>
        <div
          style="
            text-align: left;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 40px;
            background-color: rgb(240, 248, 246);
            padding: 10px;
            box-sizing: border-box;
          "
          v-html="bmxzContent"
          v-if="bmxzContent"></div>
        <div
          style="
            text-align: left;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 40px;
            background-color: rgb(240, 248, 246);
            padding: 10px;
            box-sizing: border-box;
          "
          v-else>
          <p>一、报名人持下列材料到本县农村产权交易服务中心报名：</p>
          <p>1、有效资格证件：</p>
          <p>
            （1）意向受让方为自然人，需提供本人身份证复印件或常住人口户口簿复印件；
          </p>
          <p>
            （2） 意向受让方为公司，需提供
            法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、公司章程以及董事会或股东（大）会同意受让决议；
          </p>
          <p>
            （3）
            意向受让方为合作社，需提供法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、合作社成员同意受让决议。
          </p>
          <p>2、若为授权人提出申请，需提供授权委托书及身份证复印件。</p>
          <p>
            二、挂牌期满，若征集到符合条件的意向受让方，采取协议或者竞标方式确定受让方。
          </p>
          <p>三、法定节假日、公休日不受理报名。</p>
        </div>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">竞拍须知</el-divider>
          </div>
        </div>

        <div
          style="
            text-align: left;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 40px;
            background-color: rgb(240, 248, 246);
            padding: 10px;
            box-sizing: border-box;
          "
          v-if="jpxzContent"
          v-html="jpxzContent"></div>

        <div
          v-else
          style="
            text-align: left;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 40px;
            background-color: rgb(240, 248, 246);
            padding: 10px;
            box-sizing: border-box;
          ">
          <p>
            一、交易保证金缴付方式及要求：
            意向受让方可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式缴付交易保证金。
            如果意向受让方未按规定方式缴付交易保证金，将会造成交易保证金无法退还，由此产生的一切后果和责任，由意向受让方自行承担。
          </p>
          <p>
            1、交纳保证金之前，意向受让方需到县农交中心官网挂牌交易项目中查看获取保证金账户信息；
          </p>
          <p>
            2、通过银行柜台转账的，在缴款时须在银行进账单或汇款凭证的备注/用途/附言栏中准确填写项目编号；
          </p>
          <p>
            3、通过网上银行/手机银行转账的，在缴款时须在网上银行支付界面的备注/用途/银行附言栏中准确填写项目编号；
          </p>
          <p>
            4、通过线上支付方式缴付的，意向受让方需留意报名界面提示的相关注意事项。
          </p>
          <p>二、交易保证金缴付注意事项：</p>
          <p>
            1、意向受让方报名时应准确填写银行账户信息，且保证填写的账户信息与保证金交纳账户信息一致。若因意向受让方未按要求填写相关信息而导致其无法参与竞价的，由此产生的一切后果和责任由意向受让方自行承担；
          </p>
          <p>
            2、意向受让方应妥善保管交易保证金缴款凭证，该凭证将作为查询及办理相关手续的依据之一。
          </p>
          <p>
            三、报名所需材料：（以农村产权转出公告中确定的受让方条件、与转让相关的其他条件为准）
          </p>
          <p>1、有效资格证明文件：</p>
          <p>
            （1）、意向受让方为自然人的，需提供有效期内本人身份证，意向受让方限制为村民或集体经济组织成员的，还需提供《身份认证承诺书》；
          </p>
          <p>
            （2）、意向受让方为单位的，需提供有效期内的营业执照副本、机构代码证、法定代表人身份、合作社章程/公司章程（封面盖章、骑缝盖章）、合作社成员大会决议/股东会决议/董事会决议。
          </p>
          <p>2、缴款凭证；</p>
          <p>3、其他材料。</p>
          <p>
            四、报名：
            交易保证金交纳后，点击“立即报名”按钮，填写报名信息，以附件形式上传交易保证金缴款凭证和报名所需材料的照片，竞价账户密码以意向受让方注册的为准。
          </p>
          <p>
            五、项目报名时间截止后，产生两个及以上符合条件的意向受让方的，{{
              deptName
            }}农村产权中心所按照公告的竞价方式组织或指导实施公开竞价。只产生一个符合条件的意向受让方的，{{
              deptName
            }}农村产权中心组织交易双方按挂牌价与意向受让方报价孰高（或孰低）原则直接签约；意向受让方未报价的，{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}组织交易双方按挂牌价直接签约。
          </p>
          <p>
            六、实行网络竞价的项目：意向受让方登录{{
              deptName
            }}农村产权交易信息服务网，点击“我要报名”按钮，凭报名时的用户名、密码登录竞价报名，在竞价报名截止时间之前进行报价。竞价结束后，按有效报价从高到低排序，选择报价最高者竞得项目（农村小微工程项目：竞价结束后，系统按有效报价从低到高排序，选择报价最低者竞得项目）。意向受让方报价不能低于项目挂牌价格（农村小微工程项目：报价不能高于项目挂牌价格），逾期报价或不符合规定的报价做无效处理。
          </p>
          <p>
            七、意向受让方承诺在确定为受让方后严格按照转出方的要求予以开发利用，不改变原用途，不破坏农业综合生产能力，不破坏生态环境，对于需提供开发利用规划的，及时提交规划文件。
          </p>
          <p>
            八、若非转出方原因，出现下列情形之一时，保证金不予退还，转出方可以意向受让方交纳的保证金为限，在扣除县农交中心的交易服务费用和相关方费用后，剩余部分作为补偿金划归转出方，并可继续向意向受让方主张相应的补偿责任：
          </p>
          <p>（一）、意向受让方交纳竞价保证金后单方撤回受让申请的；</p>
          <p>
            （二）、征集到两家及以上符合条件的意向受让方后，均未参与后续竞价程序的；或在竞价过程中以挂牌价格为起始价格，各意向受让方均不应价的；
          </p>
          <p>
            （三）、按照{{
              deptName
            }}农交中心有关制度、规则及通知要求，意向受让方竞价成功后，未在规定时间内签订合同的；或未按约定时限支付全部交易价款合同价款和交易服务费的；或未按交易条件的要求完成标的交付交接的；
          </p>
          <p>（四）、意向受让方故意提供虚假、失实材料造成转出方损失的；</p>
          <p>
            （五）、意向受让方通过获取转出方或标的企业的商业秘密，侵害转出方合法权益的；
          </p>
          <p>
            （六）、意向受让方之间相互串通，影响公平竞争，侵害转出方合法权益的；
          </p>
          <p>
            （七）、意向受让方在竞价过程中违反竞价规则和农村产权交易相关规则，扰乱竞价秩序的；
          </p>
          <p>
            （八）、意向受让方恶意炒作、操纵市场价格、出价严重偏离市场价格等非正当手段扰乱市场交易行为的；
          </p>
          <p>（九）、意向受让方违反法律法规或相关规定给转出方造成损失的；</p>
          <p>
            （十）、{{
              deptName
            }}农交中心认定的其他破坏正常交易秩序、不推进交易或放弃受让等违反公平、公正、诚实信用的行为；
          </p>
          <p>
            （十一）、意向受让方存在其他违反交易规则、挂牌条件要求的情形。
            保证金金额不足以弥补转出方、{{
              deptName
            }}农交中心或其他相关方损失的，利益受损方可以向有过错的意向受让方继续进行追偿。
          </p>
          <p>
            九、符合前款第（二)、（三）规定的，转出方有权向{{
              deptName
            }}农交中心申请重新挂牌。
          </p>
          <p>十、法定节假日、公休日不受理报名。</p>
          <p>十一、转出方有权在网络竞价开始前自行决定撤回网络竞价标的。</p>
          <p>
            十二、本平台对相关主体所发布的项目挂牌信息不作任何承诺和担保。意向受让方有意向应到标的物现场详细察看标的物的现状和瑕疵情况，对标的有明确的认识，若标的现状与项目公告内容有差异的，以标的现状为准，一经成交交易价格不作调整。
          </p>
          <p>十三、免责声明：</p>
          <p>
            （一）、{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}对转出方或意向受让方违反法律、法规或相关规定及违约行为不承担任何责任；
          </p>
          <p>
            （二）、若出现下列任何情况，{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}不承担任何经济责任和法律责任：
          </p>
          <p>
            1、对因不可抗力因素以及{{
              deptName
            }}农交中心系统故障、设备故障、通讯故障、电力故障等突发事故所产生的不可预测或不可控制因素造成损失的；
          </p>
          <p>
            2、网络竞价的时间以竞价系统服务器时间为准。由于意向受让方自身终端设备时间与网络竞价系统服务器时间不符而导致未能按时参与报价的；
          </p>
          <p>3、意向受让方因自身原因导致其注册账户信息泄露而造成的一切后果；</p>
          <p>
            4、意向受让方因遗忘密码、自身终端设备出现故障或网络异常而不能正常参与竞价的；
          </p>
          <p>
            5、意向受让方不符合受让方条件或因自身原因未及时关注项目公告逾期报名没有取得竞价资格的；
          </p>
          <p>6、其他因意向受让方自身原因导致未能报名或正常参与交易的。</p>
          <p>
            十四、郑重提醒意向受让方：报名前请仔细核对是否符合受让方条件并对竞价资格负责；{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}发现不符合规定和相关条件的有权驳回报名或取消资格；在取得“登录账号及密码”后，务必注意登录账号和密码的安全。凡使用该账号登入平台后所进行的一切报价及所做出的一切行为，均被视为账号所属注册用户的自主有效行为，该注册用户应对行为后果承担全部经济与法律责任。
          </p>
          <p>
            十五、意向受让方应认真阅读并正确理解本《报名须知》及《{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}网络竞价实施办法（试行）》《{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}收费管理办法（试行）》《网络竞价项目承诺函》《网络竞价须知》《现场看样确认函》《现场看样承诺函》等全部的条款及内容，意向受让方一旦登录{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}使用，即表示对上述全部条款及内容予以确认，无任何异议。
          </p>
        </div>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">特别提示</el-divider>
          </div>
        </div>

        <div
          style="
            text-align: left;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 40px;
            background-color: rgb(254, 246, 244);
            padding: 10px;
            box-sizing: border-box;
          ">
          <p>1、请竞买人按网站规范要求自主登录竞价系统进行竞价。</p>
          <p>
            2、竞买人应严格遵照约定的网络报价时间参与报价，因报价人原因造成报价不及时或失效的，相关责任由竞买人承担，请切勿错过时机；请竞买人确保终端设备运行良好。
          </p>
          <p>
            3、若发生项目暂停或中止情况，{{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + '农村集体财产监督管理平台'
            }}网站发布公告为尽责告知义务。
          </p>
        </div>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">竞拍公告</el-divider>
          </div>
        </div>

        <table style="width: 100%" border="1">
          <tr>
            <th>标的名称</th>
            <td>
              {{ projectDetail.areaName + projectDetail.projectname }}
            </td>
          </tr>
          <tr>
            <th>项目编号</th>
            <td>
              {{ projectDetail.numbering }}
            </td>
          </tr>
          <tr>
            <th>报名及交纳交易保证金截止时间</th>
            <td>
              {{
                timeDetail && timeDetail.applyStopTime
              }}前(以到账为准，逾期交纳保证金者报名无效)
            </td>
          </tr>
          <tr>
            <th rowspan="5">报（竞）价方式</th>

            <td>
              报名时间：{{ timeDetail && timeDetail.applyStartTime }} 至
              {{ timeDetail && timeDetail.applyStopTime }}
            </td>
          </tr>
          <tr>
            <td>
              竞价时间：{{ timeDetail && timeDetail.biddingStartTime }} 至
              {{ timeDetail && timeDetail.biddingStopTime }}
            </td>
          </tr>
          <tr>
            <td>交易方式：电子竞价</td>
          </tr>
          <tr>
            <td>竞价单位：{{ priceUnitList[projectDetail.unit] }}</td>
          </tr>
          <tr>
            <td>
              意向受让方通过网络电子竞价系统可在动态报价时间内充分自由报价，竞价时间截止，最低报价即成为成交价；无人出价则交易结束，项目不成交。
            </td>
          </tr>
        </table>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">风险告知</el-divider>
          </div>
        </div>

        <div
          style="
            text-align: left;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 40px;
            background-color: rgb(254, 246, 244);
            padding: 10px;
            box-sizing: border-box;
          ">
          <p>
            1.转出标的的合法性以及真实性由转出方负责，此次交易过程中存在相关交易风险及法律纠纷由交易双方自行承担并解决。
          </p>
          <p>
            2.{{
              deptName
            }}农村产权交易信息服务网不对农村产权流转交易信息的真实性、准确性、完整性做出任何保证。对任何因直接或间接使用本网站内容而造成的损失，包括但不限于因有关内容不真实、不准确、不完整而导致的损失，{{
              deptName
            }}农村产权交易信息服务网不承担任何法律责任。
          </p>
          <p>
            3.竞价标的物以实物现状为准，竞买人可以在挂牌期间申请实地看样，竞买人决定参与竞价的，视为对竞价标的物完全了解，并接受一切已知和未知瑕疵。{{
              deptName
            }}农村产权交易信息服务网和转出方均不承担瑕疵担保责任。
          </p>
        </div>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">竞买登记</el-divider>
          </div>
        </div>

        <table style="width: 100%" border="1">
          <tr>
            <th>投标方资格条件</th>
            <td></td>
          </tr>
          <tr>
            <th>报名方式</th>
            <td v-if="!applyWay">
              <p>1、意向受让方首次报名须知：</p>
              <p>
                ①企业法人单位组织须提交加盖公章的《营业执照》复印件等证明主体资格的相关材料以及法定代表人身份证复印件、经办人身份证复印件、授权委托书、公章、法人章等相关材料；
              </p>
              <p>
                ②非企业法人单位须提交以下资料：申请人身份证正反面复印件1份、申请人银行卡正反面复印件1份。
              </p>
              <p>
                2、非首次报名的意向受让方按时根据保证金备注要求交纳交易保证金后即可参与本期竞价。
              </p>
              <p>3、交易中心向意向受让方发放报价账号（长期有效、注意保管）。</p>
              <p>
                4、交易保证金交纳截止日当天17:30前未收到交易账号激活短信的意向受让方，请致电交易中心。
              </p>
            </td>
            <td v-else v-html="applyWay"></td>
          </tr>
          <tr>
            <th>保证金及处理方式</th>
            <td>
              <p style="font-weight: 600">
                1、须交纳的交易保证金金额为人民币{{
                  projectDetail.bailAmount
                }}元。
              </p>
              <p style="font-weight: 600">
                2、开户行:{{
                  backCardInfo
                    ? backCardInfo.bankName
                    : cityDetail.cityName == '信阳市'
                    ? '中国建设银行股份有限公司信阳北京路支行'
                    : ''
                }}
              </p>
              <p style="font-weight: 600">
                户名:{{
                  backCardInfo
                    ? backCardInfo.cardName
                    : cityDetail.cityName == '信阳市'
                    ? '信阳市申资产权交易有限责任公司'
                    : ''
                }}
              </p>
              <p style="font-weight: 600">
                账号:{{
                  backCardInfo
                    ? backCardInfo.cardNo
                    : cityDetail.cityName == '信阳市'
                    ? '41001551417050201184'
                    : ''
                }}
              </p>
              <p>
                须在交纳保证金截止时间前电话通知交易中心已交纳保证金，如未通知或不得参与竞价。
              </p>
              <p>交纳交易保证金要求：</p>
              <p>
                ①交易保证金可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式提交。
              </p>
              <p>② 交纳交易保证金时，须备注相关信息：</p>
              <p>企业：项目名称+企业名称。例：XX项目XX公司保证金；</p>
              <p>个人：项目名称+姓名。例：XX项目XX保证金；</p>
              <p>
                交易保证金交易截止时间前未正确备注信息的，资格审查不予通过。
              </p>
              <p>
                未成交者的交易保证金交易中心将在交易结束后15个工作日内全额无息返还。
              </p>
              <p>
                ③竞拍人竞买成功后，携带相关资料到交易中心缴纳服务费，在交易中心主持下与出让方签订合同。
              </p>
              <p>
                ④成交人交易保证金作为出让金转入出让方账户，溢价部分向出让方补缴齐。
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">交易方式</el-divider>
          </div>
        </div>

        <table style="width: 100%" border="1">
          <tr>
            <th>成交确认、价款支付及合同签订</th>
            <td>
              <p>
                1、成交后，受让方应在两个工作日内到交易中心或转让方处领取《成交通知书》。标的成交的，受让方未在规定的时间内到交易中心或转让方处领取《成交通知书》的，交易中心将视作受让方知晓及认可相关交易内容，认可已成交标的相关权利和义务，如由此引发的一切法律纠纷由受让方自行承担，交易中心有权追究其相关法律责任。
              </p>
              <p>
                2、受让方须在成交之次日起5个工作日内持《成交通知书》和付款凭证与招标方签订《招标合同》，约定双方相关的责任和义务；
              </p>
              <p>
                3、受让方不根据本公告要求履约的，视为自动放弃受让资格，其已交纳的交易保证金不予退回，并对交易中心因此造成的损失承担赔偿责任，招标方有权将该标重新组织竞买交易。
              </p>
            </td>
          </tr>
          <tr>
            <th>投标方资格条件</th>
            <td>双方按相关合同约定进行交割。</td>
          </tr>
        </table>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">其他事项</el-divider>
          </div>
        </div>

        <div
          style="
            text-align: left;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 40px;
            background-color: rgb(240, 248, 246);
            padding: 10px;
            box-sizing: border-box;
          ">
          <p>
            1、意向受让方参与交易前应仔细阅读本信息公告、“附件”中所有材料、阅读了解{{
              deptName
            }}农村综合产权交易中心相关交易规则等有关材料，一旦参与交易（报名）则视为意向受让方已充分了解并接受信息公告（含附件材料）、{{
              deptName
            }}农村综合产权交易中心交易规则等全部内容，愿意承担可能存在的一切交易风险。
          </p>
          <p>
            2、{{ deptName }}农村综合产权交易中心相关交易规则请查看{{
              deptName
            }}农村综合产权交易中心官网：交易指南 — 交易规则
          </p>
        </div>
      </div>
      <div v-show="getDetailActive == 5">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">交易公告</el-divider>
          </div>
        </div>
        <!-- 采购公告 9月15日 -->
        <!-- <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.projectname }}采购项目
          </p>
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            采购公告
          </p>
          <p style="text-indent: 2em">
            根据<span style="text-decoration: underline"
              >辉县市{{ projectDetail.needname }}</span
            >申请，定于<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.biddingStartTime)
            }}</span
            >在辉县市农村综合产权交易中心http://117.159.15.238:16035/#/网络竞价平台对<span
              style="text-decoration: underline"
              >{{ projectDetail.areaName + projectDetail.projectname }}</span
            >项目进行公开竞价（反向），现将采购公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 600">一、项目基本情况</p>
          <p style="text-indent: 2em">
            1.项目编号：<span style="text-decoration: underline">{{
              projectDetail.numbering
            }}</span>
          </p>
          <p style="text-indent: 2em">
            2.项目名称：<span style="text-decoration: underline">{{
              projectDetail.areaName + projectDetail.projectname
            }}</span>
          </p>
          <p style="text-indent: 2em">3.采购方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            4.预算总额：<span style="text-decoration: underline">{{
              projectDetail.price
            }}</span
            >元（最高限价）
          </p>
          <p style="text-indent: 2em">
            5.项目地址：辉县市<span style="text-decoration: underline">{{
              projectDetail.areaName
            }}</span>
          </p>
          <p style="text-indent: 2em">
            6.标段划分：<span style="text-decoration: underline"
              >本项目共划分为一个标段</span
            >
          </p>
          <p style="text-indent: 2em">
            7.质量标准：<span style="text-decoration: underline"
              >合格，达到国家质量验收标准</span
            >
          </p>
          <p style="text-indent: 2em">
            8.合同期限：<span style="text-decoration: underline"
              >合同签订后30日历日</span
            >
          </p>
          <p style="text-indent: 2em">
            9.资金来源：<span style="text-decoration: underline">自筹资金</span>
          </p>
          <p style="text-indent: 2em">
            10.付款方式：双方根据合同约定付款方式进行付款。
          </p>
          <p style="text-indent: 2em">11.履约保证金：无</p>
          <p style="text-indent: 2em">12.项目是否接受联合体：否</p>
          <p style="text-indent: 2em; font-weight: 600">二、供应商的资格要求</p>
          <p style="text-indent: 2em">
            1.需具有有效的营业执照，有相应的经营范围。
          </p>
          <p style="text-indent: 2em">2.具有独立承担民事责任的能力。</p>
          <p style="text-indent: 2em">3.具有良好的商业信誉。</p>
          <p style="text-indent: 2em">
            4.具有履行合同所必需的设备和专业技术能力。
          </p>
          <p style="text-indent: 2em">5.有依法缴纳税收的良好记录。</p>
          <p style="text-indent: 2em">
            6.信誉要求：列入失信被执行人、重大税收违法失信主体、政府采购严重违法失信行为记录名单的供应商，将拒绝参与本次交易活动。
          </p>
          <p style="text-indent: 2em">
            【查询渠道：1.“信用中国”网站www.creditchina.gov.cn查询内容:重大税收违法失信主体；2.“中国执行信息公开网”网站http://zxgk.court.gov.cn查询内容为：失信被执行人；3.中国政府采购网www.ccgp.gov.cn查询内容为：政府采购严重违法失信行为记录名单】。
          </p>
          <p style="text-indent: 2em; font-weight: 600">三、报名方式</p>
          <p style="text-indent: 2em">
            1.报名截止时间：<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.applyStopTime)
            }}</span
            >。
          </p>
          <p style="text-indent: 2em">2.报名注意事项：</p>
          <p style="text-indent: 2em">
            2.1意向供应商须在<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.applyStopTime)
            }}</span
            >前登录辉县市农村综合产权交易中心官网http://117.159.15.238:16035/#/，按要求进行实名注册及报名。
          </p>
          <p style="text-indent: 2em">
            2.2意向供应商需在<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.applyStopTime)
            }}</span
            >前按要求上传相关资料进行资格审核。
          </p>
          <p style="text-indent: 2em; font-weight: 600">四、保证金</p>
          <p style="text-indent: 2em">
            1.保证金金额：<span style="text-decoration: underline"
              >{{ projectDetail.bailAmount }}元人民币（大写：人民币{{
                bigWrite(projectDetail.bailAmount)
              }}整）。</span
            >
          </p>
          <p style="text-indent: 2em">
            2.保证金到账截止时间：<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.applyStopTime)
            }}</span
            >（北京时间）。
          </p>
          <p style="text-indent: 2em">
            3.保证金交纳请联系：18236953278/13753689950
          </p>
          <p style="text-indent: 2em">
            注：保证金未在规定时间到账、未交纳到指定账号或无效交纳的，该意向供应商不能参与竞价。汇款时请注明该笔费用为保证金，并备注项目名称或项目编号（须为供应商账户汇出）。
          </p>
          <p style="text-indent: 2em; font-weight: 600">五、公开竞价</p>
          <p style="text-indent: 2em">
            1.竞价开始时间：<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.biddingStartTime)
            }}</span
            >（北京时间）。
          </p>
          <p style="text-indent: 2em">2.竞价方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            3.自由竞价时间：<span style="text-decoration: underline"
              >{{
                formatDate(projectDetail.releaseRecord.biddingStartTime)
              }}至{{
                formatDate(projectDetail.releaseRecord.biddingStopTime)
              }}。</span
            >
          </p>
          <p style="text-indent: 2em">
            注：供应商在竞价开始10分钟前登录系统并进入竞价大厅，遇见技术问题请及时与我中心联系沟通解决。
          </p>
          <p style="text-indent: 2em; font-weight: 600">六、确定成交供应商</p>
          <p style="text-indent: 2em">1.采购人按照报价最低原则确定成交人。</p>
          <p style="text-indent: 2em">
            2.报价最低的供应商放弃成交的，其交纳的保证金不予退还并作为违约金由农交中心予以没收。对意向供应商失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">七、声明</p>
          <p style="text-indent: 2em">
            进入网络竞价环节且出价的意向供应商即视为完全同意并响应交易公告、交易文件的全部内容，成交之后不得再以此为由提出任何异议。成交供应商所供的标的及服务（工程服务）必须实质性满足交易公告、交易文件的全部需求，若不满足上述要求，其保证金将不予退还并作为违约金由农交中心予以没收。意向供应商所提供的标的及服务（工程服务）若未按交易公告、交易文件要求或未完全满足交易公告、交易文件要求的，将会列入农交中心诚信评价体系。对意向供应商失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">八、发布公告的媒介</p>
          <p style="text-indent: 2em">
            本次交易公告在辉县市农村综合产权交易中心官网http://117.159.15.238:16035/#/上发布。
          </p>
          <p style="text-indent: 2em; font-weight: 600">九、联系方式</p>
          <p style="text-indent: 2em">
            申请人：<span style="text-decoration: underline"
              >辉县市{{ projectDetail.needname }}</span
            >
          </p>
          <p style="text-indent: 2em">
            地址：<span style="text-decoration: underline">{{
              projectDetail.areaName
            }}</span>
          </p>
          <p style="text-indent: 2em">
            联系人：<span style="text-decoration: underline">{{
              projectDetail.legalperson
            }}</span>
          </p>
          <p style="text-indent: 2em">
            联系电话：<span style="text-decoration: underline">{{
              realPhone ||projectDetail.phone
            }}</span><img
                    src="../assets/img/openEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    @click="checkShowPhone"
                  />
          </p>
          <p style="text-indent: 2em">组织机构：辉县市农村综合产权交易中心</p>
          <p style="text-indent: 2em">地址：辉县市政务服务大厅二楼南侧</p>
          <p style="text-indent: 2em">联系人：张老师 /朱老师</p>
          <p style="text-indent: 2em">联系电话：0373-6053001 / 0373-6053002</p>
          <p style="text-indent: 2em; text-align: right">
            辉县市农村综合产权交易中心
          </p>
          <p style="text-indent: 2em; text-align: right">
            {{ formatDate(projectDetail.releaseRecord.publicityStartTime) }}
          </p>
        </div> -->
        <!-- 工程类交易公告 9月15日 -->
        <!-- <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.areaName + projectDetail.projectname }}项目
          </p>
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            采购公告
          </p>
          <p style="text-indent: 2em">
            根据<span>辉县市{{ projectDetail.needname }}</span
            >申请，定于<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.biddingStartTime)
            }}</span
            >在辉县市农村综合产权交易中心http://117.159.15.238:16035/#/网络竞价平台对<span
              >{{ projectDetail.projectname }}项目</span
            >进行公开竞价（反向），现将交易公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 600">一、项目基本情况</p>
          <p style="text-indent: 2em">
            1.项目编号：<span style="text-decoration: underline">{{
              projectDetail.numbering
            }}</span>
          </p>
          <p style="text-indent: 2em">
            2.项目名称：<span style="text-decoration: underline">{{
              projectDetail.projectname
            }}</span>
          </p>
          <p style="text-indent: 2em">3.交易方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            4.预算总额：<span style="text-decoration: underline">
              {{ projectDetail.price }} </span
            >元（最高限价）
          </p>
          <p style="text-indent: 2em">
            5.项目地址：<span style="text-decoration: underline"
              >辉县市{{ projectDetail.address }}</span
            >
          </p>
          <p style="text-indent: 2em">
            6.标段划分：<span style="text-decoration: underline"
              >本项目共划分为一个标段</span
            >
          </p>
          <p style="text-indent: 2em">
            7.质量标准：<span style="text-decoration: underline"
              >合格，达到国家质量验收标准</span
            >
          </p>
          <p style="text-indent: 2em">
            8.合同期限：<span style="text-decoration: underline"
              >合同签订后30日历日</span
            >
          </p>
          <p style="text-indent: 2em">
            9.资金来源：<span style="text-decoration: underline">自筹资金</span>
          </p>
          <p style="text-indent: 2em">
            10.付款方式：双方根据合同约定付款方式进行付款。
          </p>
          <p style="text-indent: 2em">11.履约保证金：无</p>
          <p style="text-indent: 2em">12.项目是否接受联合体：否</p>
          <p style="text-indent: 2em; font-weight: 600">二、投标人的资格要求</p>
          <p style="text-indent: 2em">
            1.需具有有效的资格证书，有相应的经营范围。
          </p>
          <p style="text-indent: 2em">2.具有独立承担民事责任的能力。</p>
          <p style="text-indent: 2em">3.具有良好的商业信誉。</p>
          <p style="text-indent: 2em">
            4.具有履行合同所必需的设备和专业技术能力。
          </p>
          <p style="text-indent: 2em">5.有依法缴纳税收的良好记录。</p>
          <p style="text-indent: 2em">
            6.信誉要求：列入失信被执行人、重大税收违法失信主体、政府采购严重违法失信行为记录名单的投标人，将拒绝参与本次交易活动。
          </p>
          <p style="text-indent: 2em">
            【查询渠道：1.“信用中国”网站www.creditchina.gov.cn查询内容:重大税收违法失信主体；2.“中国执行信息公开网”网站http://zxgk.court.gov.cn查询内容为：失信被执行人；3.中国政府采购网www.ccgp.gov.cn查询内容为：政府采购严重违法失信行为记录名单】。
          </p>
          <p style="text-indent: 2em; font-weight: 600">三、报名方式</p>
          <p style="text-indent: 2em">
            1.报名截止时间：<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.applyStopTime
            }}</span
            >。
          </p>
          <p style="text-indent: 2em">2.报名注意事项：</p>
          <p style="text-indent: 2em">
            2.1意向投标人须在<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.applyStopTime
            }}</span
            >前登录辉县市农村综合产权交易中心官网http://117.159.15.238:16035/#/，按要求进行实名注册及报名。
          </p>
          <p style="text-indent: 2em">
            2.2意向供应商需在<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.applyStopTime
            }}</span
            >前按要求上传相关资料进行资格审核。
          </p>
          <p style="text-indent: 2em; font-weight: 600">四、保证金</p>
          <p style="text-indent: 2em">
            1.保证金金额：<span style="text-decoration: underline"
              >{{ projectDetail.bailAmount }}元人民币（大写：人民币{{
                bigWrite(projectDetail.bailAmount)
              }}整）。</span
            >
          </p>
          <p style="text-indent: 2em">
            2.保证金到账截止时间：<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.applyStopTime)
            }}</span
            >（北京时间）。
          </p>
          <p style="text-indent: 2em">
            3.保证金交纳请联系：18236953278/13753689950
          </p>
          <p style="text-indent: 2em">
            注：保证金未在规定时间到账、未交纳到指定账号或无效交纳的，该意向投标人不能参与竞价。汇款时请注明该笔费用为保证金，并备注项目名称或项目编号（须为投标人账户汇出）。
          </p>
          <p style="text-indent: 2em; font-weight: 600">五、公开竞价</p>
          <p style="text-indent: 2em">
            1.竞价开始时间：<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.biddingStartTime)
            }}</span
            >（北京时间）。
          </p>
          <p style="text-indent: 2em">2.竞价方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            3.自由竞价时间：<span style="text-decoration: underline"
              >{{
                formatDate(projectDetail.releaseRecord.biddingStartTime)
              }}至{{
                formatDate(projectDetail.releaseRecord.biddingStopTime)
              }}。</span
            >
          </p>
          <p style="text-indent: 2em">
            注：供应商在竞价开始10分钟前登录系统并进入竞价大厅，遇见技术问题请及时与我中心联系沟通解决。
          </p>
          <p style="text-indent: 2em; font-weight: 600">六、确定成交供应商</p>
          <p style="text-indent: 2em">1.投标人按照报价最低原则确定成交人。</p>
          <p style="text-indent: 2em">
            2.报价最低的投标人放弃成交的，其交纳的保证金不予退还并作为违约金由农交中心予以没收。对意向投标人失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">七、声明</p>
          <p style="text-indent: 2em">
            进入网络竞价环节且出价的意向投标人即视为完全同意并响应交易公告、交易文件的全部内容，成交之后不得再以此为由提出任何异议。成交投标人所供的标的及服务（工程服务）必须实质性满足交易公告、交易文件的全部需求，若不满足上述要求，其保证金将不予退还并作为违约金由农交中心予以没收。意向投标人所提供的标的及服务（工程服务）若未按交易公告、交易文件要求或未完全满足交易公告、交易文件要求的，将会列入农交中心诚信评价体系。对意向投标人失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">八、发布公告的媒介</p>
          <p style="text-indent: 2em">
            本次交易公告在辉县市农村综合产权交易中心官网http://117.159.15.238:16035/#/上发布。
          </p>
          <p style="text-indent: 2em; font-weight: 600">九、联系方式</p>
          <p style="text-indent: 2em">
            申请人：<span style="text-decoration: underline"
              >辉县市{{ projectDetail.needname }}</span
            >
          </p>
          <p style="text-indent: 2em">
            地址：<span style="text-decoration: underline">{{
              projectDetail.areaName
            }}</span>
          </p>
          <p style="text-indent: 2em">
            联系人：<span style="text-decoration: underline">{{
              projectDetail.legalperson
            }}</span>
          </p>
          <p style="text-indent: 2em">
            联系电话：<span style="text-decoration: underline">{{
              realPhone ||projectDetail.phone
            }}</span><img
                    src="../assets/img/openEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    @click="checkShowPhone"
                  />
          </p>
          <p style="text-indent: 2em">组织机构：辉县市农村综合产权交易中心</p>
          <p style="text-indent: 2em">地址：辉县市政务服务大厅二楼南侧</p>
          <p style="text-indent: 2em">联系人：张老师 /朱老师</p>
          <p style="text-indent: 2em">联系电话：0373-6053001 / 0373-6053002</p>
          <p style="text-indent: 2em; text-align: right">
            辉县市农村综合产权交易中心
          </p>
          <p style="text-indent: 2em; text-align: right">
            {{ formatDate(projectDetail.releaseRecord.publicityStartTime) }}
          </p>
        </div> -->
        <!-- 经营性土地交易公告 9月15日 没写完 -->
        <!-- <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.areaName + projectDetail.projectname }}项目
          </p>
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            交易公告
          </p>
          <p style="text-indent: 2em">
            根据转出方申请，定于<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.biddingStartTime
            }}</span
            >在辉县市农村综合产权交易中心http://117.159.15.238:16035/网络竞价平台对下列标的进行公开交易，现将交易事项公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 600">一、标的概述</p>
          <p style="text-indent: 2em">
            1.项目名称：<span style="text-decoration: underline">{{
              projectDetail.areaName + projectDetail.projectname
            }}</span>
          </p>
          <p style="text-indent: 2em">
            2.项目编号：<span style="text-decoration: underline">{{
              projectDetail.numbering
            }}</span>
          </p>
          <p style="text-indent: 2em">
            3.项目位置：<span style="text-decoration: underline">{{
              projectDetail.address
            }}</span>
          </p>
          <p style="text-indent: 2em">
            4.标的面积：<span style="text-decoration: underline">{{
              projectDetail.area + projectDetail.unit
            }}</span>
          </p>
          <p style="text-indent: 2em">
            5.出租期限：<span style="text-decoration: underline"
              >{{ getYearLimit() }}年</span
            >
          </p>
          <p style="text-indent: 2em">
            6.转出方式：<span style="text-decoration: underline">{{
              getDictValue(projectDetail.transType, "out_type")
            }}</span>
          </p>
          <p style="text-indent: 2em">
            7.交易起始价：<span style="text-decoration: underline">{{
              projectDetail.price + " 元/" + projectDetail.unit
            }}</span>
          </p>
          <p style="text-indent: 2em">
            8.风险保障金：<span style="text-decoration: underline">无</span>
          </p>
          <p style="text-indent: 2em">
            9.付款方式：<span style="text-decoration: underline">年付</span>
          </p>
          <p style="text-indent: 2em">
            10.交易保证金：<span style="text-decoration: underline"
              >{{ projectDetail.bailAmount }}元</span
            >
          </p>
          <p style="text-indent: 2em; font-weight: 600">二、交易方式</p>
          <p style="text-indent: 2em">本次交易采用网络竞价的方式。</p>
          <p style="text-indent: 2em; font-weight: 600">三、受让人条件</p>
          <p style="text-indent: 2em">
            凡具备完全民事行为能力和支付能力的公民、法人和其他组织均可参加。
          </p>
          <p style="text-indent: 2em; font-weight: 600">四、报名有关事项</p>
          <p style="text-indent: 2em">
            意向人可采用线上或线下任一种方式进行报名：
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">1.线下报名：</span
            >自然人持身份证原件，法人和其他组织持有效工商营业执照（或组织机构证明）、法定代表人证明书（或法人授权委托书）等证明材料，到我中心办理竞价登记手续。
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">2.线上报名：</span>
          </p>
          <p style="text-indent: 2em">
            （1）PC端：登录辉县市农村综合产权交易中心官网进行报名及注册登记。
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">3.</span>意向人须在<span
              style="text-decoration: underline"
              >{{
                formatDate(projectDetail.releaseRecord.biddingStartTime)
              }}</span
            >前（以实际到账为准）交纳
            <span>{{ projectDetail.bailAmount }}</span>
            元的交易保证金。保证金缴纳联系人：18236953278/13753689950。若受让不成功，交易保证金于交易结束后三个工作日内全额无息原路退还。
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">4.</span>报名截止时间：{{
              formatDate(projectDetail.releaseRecord.applyStopTime)
            }}
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">5.</span>竞价开始时间：{{
              formatDate(projectDetail.releaseRecord.biddingStartTime)
            }}
          </p>
          <p style="text-indent: 2em; font-weight: 600">五、展示时间地点</p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">展示时间：</span>自公告之日起
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">展示地点：</span>标的所在地
          </p>
          <p style="text-indent: 2em; font-weight: 600">六、特别提醒</p>
          <p style="text-indent: 2em">
            1.意向人在交易前请务必仔细阅读理解《交易须知》《<span
              style="text-decoration: underline"
              >辉县市农村集体经济合同管理办法（试行）</span
            >》有关条款内容，意向人一经办理竞价手续视同完全了解并认同相关文件内容。
          </p>
          <p style="text-indent: 2em">
            2.请意向人在竞价开始前10分钟登录竞价大厅，以免因其他原因造成无法进入竞价大厅。
          </p>
          <p style="text-indent: 2em; font-weight: 600">七、咨询方式</p>
          <p style="text-indent: 2em">咨询电话：13753689950</p>
          <p style="text-indent: 7em">18236953278</p>
          <p style="text-indent: 2em">网   址： http://117.159.15.238:16035/</p>
          <p style="text-indent: 2em; text-align: right">
            辉县市农村综合产权交易中心
          </p>
          <p style="text-indent: 2em; text-align: right">
            {{ formatDate(projectDetail.createTime) }}
          </p>
        </div> -->
        <!-- 土地流转交易公告 9月15日 -->
        <!-- <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.areaName + projectDetail.projectname }}项目
          </p>
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            交易公告
          </p>
          <p style="text-indent: 2em">
            根据转出方申请，定于<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.biddingStartTime)
            }}</span
            >在辉县市农村综合产权交易中心（http://117.159.15.238:16035/）网络竞价平台对下列标的进行公开交易，现将交易事项公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 600">一、标的概述</p>
          <p style="text-indent: 2em">
            1.项目名称：<span style="text-decoration: underline">{{
              projectDetail.areaName + projectDetail.projectname
            }}</span>
          </p>
          <p style="text-indent: 2em">
            2.项目编号：<span style="text-decoration: underline">{{
              projectDetail.numbering
            }}</span>
          </p>
          <p style="text-indent: 2em">
            3.项目位置：<span style="text-decoration: underline"
              >辉县市{{ projectDetail.address }}</span
            >
          </p>
          <p style="text-indent: 2em">
            4.标的面积：<span style="text-decoration: underline">{{
              projectDetail.area + projectDetail.unit
            }}</span>
          </p>
          <p style="text-indent: 2em">
            5.出租期限：<span style="text-decoration: underline"
              >{{ getYearLimit() }}年</span
            >
          </p>
          <p style="text-indent: 2em">
            6.转出方式：<span style="text-decoration: underline">{{
              getDictValue(projectDetail.transType, "out_type")
            }}</span>
          </p>
          <p style="text-indent: 2em">
            7.交易起始价：<span style="text-decoration: underline">{{
              projectDetail.price + "元/" + projectDetail.unit
            }}</span>
          </p>
          <p style="text-indent: 2em">
            8.风险保障金：<span style="text-decoration: underline">无</span>
          </p>
          <p style="text-indent: 2em">
            9.付款方式：<span style="text-decoration: underline">年付</span>
          </p>
          <p style="text-indent: 2em">
            10.交易保证金：<span style="text-decoration: underline"
              >{{ projectDetail.bailAmount }}元</span
            >
          </p>
          <p style="text-indent: 2em; font-weight: 700">二、交易方式</p>
          <p style="text-indent: 2em">本次交易采用网络竞价的方式。</p>
          <p style="text-indent: 2em; font-weight: 700">三、受让人条件</p>
          <p style="text-indent: 2em">
            凡具备完全民事行为能力和支付能力的公民、法人和其他组织均可参加。
          </p>
          <p style="text-indent: 2em; font-weight: 700">四、报名有关事项</p>
          <p style="text-indent: 2em">
            意向人可采用线上或线下任一种方式进行报名：
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">1.线下报名：</span
            >自然人持身份证原件，法人和其他组织持有效工商营业执照（或组织机构证明）、法定代表人证明书（或法人授权委托书）等证明材料，到我中心办理竞价登记手续。
          </p>
          <p style="text-indent: 2em; font-weight: 700">2.线上报名：</p>
          <p style="text-indent: 2em">
            （1）PC端：登录辉县市农村综合产权交易中心官网进行报名及注册登记。
          </p>
          <p style="text-indent: 2em">
            3.意向人须在<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.biddingStartTime
            }}</span
            >前（以实际到账为准）交纳<span style="text-decoration: underline">{{
              projectDetail.bailAmount
            }}</span
            >元的交易保证金。保证金缴纳联系人：18236953278/13753689950。若受让不成功，交易保证金于交易结束后三个工作日内全额无息原路退还。
          </p>
          <p style="text-indent: 2em">
            4.报名截止时间：<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.applyStopTime
            }}</span>
          </p>
          <p style="text-indent: 2em">
            5.竞价开始时间：<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.biddingStartTime
            }}</span>
          </p>
          <p style="text-indent: 2em; font-weight: 700">五、展示时间地点</p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">展示时间：</span>自公告之日起
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">展示地点：</span>标的所在地
          </p>
          <p style="text-indent: 2em; font-weight: 700">六、特别提醒</p>
          <p style="text-indent: 2em">
            1.意向人在交易前请务必仔细阅读理解《交易须知》《<span
              style="text-decoration: underline"
              >辉县市农村集体经济合同管理办法（试行）</span
            >》有关条款内容，意向人一经办理竞价手续视同完全了解并认同相关文件内容。
          </p>
          <p style="text-indent: 2em">
            2.请意向人在竞价开始前10分钟登录竞价大厅，以免因其他原因造成无法进入竞价大厅。
          </p>
          <p style="text-indent: 2em; font-weight: 700">七、咨询方式</p>
          <p style="text-indent: 2em">咨询电话：13753689950</p>
          <p style="text-indent: 7em">18236953278</p>
          <p style="text-indent: 2em">网   址： http://117.159.15.238:16035/</p>
          <p style="text-indent: 2em; text-align: right">
            辉县市农村综合产权交易中心
          </p>
          <p style="text-indent: 2em; text-align: right">
            {{ formatDate(projectDetail.createTime) }}
          </p>
        </div> -->
        <!-- 租赁项目交易公告 9月17日 -->
        <!-- <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.areaName + projectDetail.projectname }}项目交易公告
          </p>
          <p style="text-indent: 2em">
            根据转出方申请，定于<span style="text-decoration: underline">{{
              formatDate(projectDetail.releaseRecord.biddingStartTime)
            }}</span
            >在辉县市农村综合产权交易中心（http://117.159.15.238:16035/）网络竞价平台对下列标的进行公开交易，现将交易事项公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 600">一、标的概述</p>
          <p style="text-indent: 2em">
            1.项目名称：<span style="text-decoration: underline"
              >辉县市{{
                projectDetail.address + projectDetail.projectname
              }}项目</span
            >
          </p>
          <p style="text-indent: 2em">
            2.项目编号：<span style="text-decoration: underline">{{
              projectDetail.numbering
            }}</span>
          </p>
          <p style="text-indent: 2em">
            3.项目位置：<span style="text-decoration: underline">{{
              projectDetail.address
            }}</span>
          </p>
          <p style="text-indent: 2em">
            4.标的面积：<span style="text-decoration: underline">{{
              projectDetail.area + projectDetail.unit
            }}</span>
          </p>
          <p style="text-indent: 2em">
            5.出租期限：<span style="text-decoration: underline">{{
              getYearLimit()
            }}</span>
          </p>
          <p style="text-indent: 2em">
            6.转出方式：<span style="text-decoration: underline">{{
              getDictValue(projectDetail.transType, "out_type")
            }}</span>
          </p>
          <p style="text-indent: 2em">
            7.交易起始价：<span style="text-decoration: underline">{{
              projectDetail.price + " 元/" + projectDetail.unit
            }}</span>
          </p>
          <p style="text-indent: 2em">
            8.风险保障金：<span style="text-decoration: underline">无</span>
          </p>
          <p style="text-indent: 2em">
            9.付款方式：<span style="text-decoration: underline">年付</span>
          </p>
          <p style="text-indent: 2em">
            10.交易保证金：<span style="text-decoration: underline"
              >{{ projectDetail.bailAmount }}元</span
            >
          </p>
          <p style="text-indent: 2em; font-weight: 600">二、交易方式</p>
          <p style="text-indent: 2em">本次交易采用网络竞价的方式。</p>
          <p style="text-indent: 2em; font-weight: 600">三、受让人条件</p>
          <p style="text-indent: 2em">
            凡具备完全民事行为能力和支付能力的公民、法人和其他组织均可参加。
          </p>
          <p style="text-indent: 2em; font-weight: 600">四、报名有关事项</p>
          <p style="text-indent: 2em">
            向人可采用线上或线下任一种方式进行报名：
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">1.线下报名：</span
            >自然人持身份证原件，法人和其他组织持有效工商营业执照（或组织机构证明）、法定代表人证明书（或法人授权委托书）等证明材料，到我中心办理竞价登记手续。
          </p>
          <p style="text-indent: 2em; font-weight: 600">2.线上报名：</p>
          <p style="text-indent: 2em">
            （1）PC端：登录辉县市农村综合产权交易中心官网进行报名及注册登记。
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">3.</span>意向人须在<span
              style="text-decoration: underline"
              >{{
                formatDate(projectDetail.releaseRecord.biddingStartTime)
              }}</span
            >前（以实际到账为准）交纳<span style="text-decoration: underline">{{
              projectDetail.bailAmount
            }}</span
            >元的交易保证金。保证金缴纳联系人：18236953278/13753689950。若受让不成功，交易保证金于交易结束后三个工作日内全额无息原路退还。
          </p>
          <p style="text-indent: 2em">
            4.报名截止时间：<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.applyStopTime
            }}</span>
          </p>
          <p style="text-indent: 2em">
            5.竞价开始时间：<span style="text-decoration: underline">{{
              projectDetail.releaseRecord.biddingStartTime
            }}</span>
          </p>
          <p style="text-indent: 2em; font-weight: 600">五、展示时间地点</p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">展示时间：</span>自公告之日起
          </p>
          <p style="text-indent: 2em">
            <span style="font-weight: 600">展示地点：</span>标的所在地
          </p>
          <p style="text-indent: 2em; font-weight: 600">六、特别提醒</p>
          <p style="text-indent: 2em">
            1.意向人在交易前请务必仔细阅读理解《交易须知》《<span
              style="text-decoration: underline"
              >辉县市农村集体经济合同管理办法（试行）</span
            >》《房屋租赁经营权合同》有关条款内容，意向人一经办理竞价手续视同完全了解并认同相关文件内容。
          </p>
          <p style="text-indent: 2em">
            2.请意向人在竞价开始前10分钟登录竞价大厅，以免因其他原因造成无法进入竞价大厅。
          </p>
          <p style="text-indent: 2em; font-weight: 600">七、咨询方式</p>
          <p style="text-indent: 2em">咨询电话：13753689950</p>
          <p style="text-indent: 7em">18236953278</p>
          <p style="text-indent: 2em">网   址： http://117.159.15.238:16035/</p>
          <p style="text-indent: 2em; text-align: right">
            辉县市农村综合产权交易中心
          </p>
          <p style="text-indent: 2em; text-align: right">
            {{ formatDate(projectDetail.createTime) }}
          </p>
        </div> -->
        <!-- 当前版本 9月16日 -->
        <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.projectname }}项目交易公告
          </p>
          <br />
          <p style="text-indent: 2em">
            根据采购人申请，定于{{
              formatDate(timeDetail.biddingStartTime)
            }}在辉县市农村综合产权交易中心http://117.159.15.238:16035/网络竞价平台对{{
              projectDetail.projectname
            }}项目进行公开竞价（反向）采购，现将采购事项公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 600">一、项目基本情况</p>
          <p style="text-indent: 2em">
            1.项目编号：{{ projectDetail.numbering }}
          </p>
          <p style="text-indent: 2em">
            2.项目名称：{{ projectDetail.projectname }}
          </p>
          <p style="text-indent: 2em">3.采购方式：网络竞价（反向）采购</p>
          <p style="text-indent: 2em">
            4.预算总额：{{ projectDetail.price }}元（最高限价）
          </p>
          <p style="text-indent: 2em">
            5.项目地址：{{ projectDetail.areaName }}
          </p>
          <p style="text-indent: 2em">6.标段划分：本项目共划分为一个标段</p>
          <p style="text-indent: 2em">7.质量标准：合格，达到国家质量验收标准</p>
          <p style="text-indent: 2em">8.合同期限：合同签订后7日历日</p>
          <p style="text-indent: 2em">9.资金来源：自筹资金</p>
          <p style="text-indent: 2em">
            10.付款方式：供应商将货物送达采购方指定地点后，经采购方验收合格后，供应商出具正规全额发票后采购方10内一次性支付货款
          </p>
          <p style="text-indent: 2em">11.履约保证金：无</p>
          <p style="text-indent: 2em">12.项目是否接受联合体：否</p>
          <p style="text-indent: 2em">
            13.采购需求：{{ projectDetail.projectname }}项目采购清单内所有内容
          </p>
          <p style="text-indent: 2em; font-weight: 600">二、供应商的资格要求</p>
          <p style="text-indent: 2em">
            1.需具有有效的营业执照，有相应的经营范围。
          </p>
          <p style="text-indent: 2em">2.具有独立承担民事责任的能力。</p>
          <p style="text-indent: 2em">3.具有良好的商业信誉。</p>
          <p style="text-indent: 2em">
            4.具有履行合同所必需的设备和专业技术能力。
          </p>
          <p style="text-indent: 2em">5.有依法缴纳税收的良好记录。</p>
          <p style="text-indent: 2em">
            6.信誉要求：列入失信被执行人、重大税收违法失信主体、政府采购严重违法失信行为记录名单的供应商，将拒绝参与本次采购活动。
          </p>
          <p style="text-indent: 2em">
            【查询渠道：1.“信用中国”网站www.creditchina.gov.cn查询内容:重大税收违法失信主体；2.“中国执行信息公开网”网站http://zxgk.court.gov.cn查询内容为：失信被执行人；3.中国政府采购网www.ccgp.gov.cn查询内容为：政府采购严重违法失信行为记录名单】。
          </p>
          <p style="text-indent: 2em">
            7.其他要求：供应商负责人为同一人或者存在控股、管理关系的不同单位，不得参加同一招标项目投标（提供“国家企业信用信息公示系统”中公示的公司信息、股东或投资人信息截图）。
          </p>
          <p style="text-indent: 2em; font-weight: 600">三、报名方式</p>
          <p style="text-indent: 2em">
            1.报名截止时间：{{
              timeDetail ? formatDate(timeDetail.applyStopTime) : ''
            }}。
          </p>
          <p style="text-indent: 2em">2.报名注意事项：</p>
          <p style="text-indent: 2em">
            2.1意向供应商须在{{
              timeDetail ? formatDate(timeDetail.applyStopTime) : ''
            }}前登录辉县市农村综合产权交易中心官网http://117.159.15.238:16035/，按要求进行实名注册及报名。
          </p>
          <p style="text-indent: 2em">
            2.2意向供应商需在{{
              timeDetail ? formatDate(timeDetail.applyStopTime) : ''
            }}前按要求上传相关资料进行资格审核。
          </p>
          <p style="text-indent: 2em; font-weight: 600">四、采购保证金</p>
          <p style="text-indent: 2em">
            1.采购保证金金额：{{
              projectDetail.bailAmount
            }}元人民币（大写：人民币{{
              bigWrite(projectDetail.bailAmount)
                ? bigWrite(projectDetail.bailAmount)
                : '零'
            }}整）。
          </p>
          <p style="text-indent: 2em">
            2.采购保证金到账截止时间：{{
              timeDetail ? formatDate(timeDetail.applyStopTime) : ''
            }}（北京时间）。
          </p>
          <p style="text-indent: 2em">
            3.保证金交纳请联系：18236953278/13753689950
          </p>
          <p style="text-indent: 2em">
            注：采购保证金未在规定时间到账、未交纳到指定账号或无效交纳的，该意向供应商不能参与竞价。汇款时请注明该笔费用为保证金，并备注项目名称或项目编号（须为供应商账户汇出）。
          </p>
          <p style="text-indent: 2em; font-weight: 600">五、采购竞价</p>
          <p style="text-indent: 2em">
            1.竞价开始时间：{{
              formatDate(timeDetail.biddingStartTime)
            }}（北京时间）。
          </p>
          <p style="text-indent: 2em">2.竞价方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            3.由竞价时间：{{ formatDate(timeDetail.biddingStartTime) }}至{{
              formatDate(timeDetail.biddingStopTime)
            }}。
          </p>
          <p style="text-indent: 2em">
            注：供应商在竞价开始10分钟前登录系统并进入竞价大厅，遇见技术问题请及时与我中心联系沟通解决。
          </p>
          <p style="text-indent: 2em; font-weight: 600">六、确定成交供应商</p>
          <p style="text-indent: 2em">
            1.采购人按照报价最低原则确定成交供应商。如只有一家意向供应商参与报价且其报价没有超过采购预算，采购人即可将其确定为成交供应商。
          </p>
          <p style="text-indent: 2em">
            2.报价最低的供应商放弃成交的，其交纳的采购保证金不予退还并作为违约金由农交中心予以没收。对意向供应商失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">七、声明</p>
          <p style="text-indent: 2em">
            进入网络竞价环节且出价的意向供应商即视为完全同意并响应采购公告、采购文件的全部内容，成交之后不得再以此为由提出任何异议。成交供应商所供的标的及服务（工程服务）必须实质性满足采购公告、采购文件的全部需求，若不满足上述要求，其采购保证金将不予退还并作为违约金由农交中心予以没收。意向供应商所提供的标的及服务（工程服务）若未按采购公告、采购文件要求或未完全满足采购公告、采购文件要求的，将会列入农交中心诚信评价体系。对意向供应商失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">八、发布公告的媒介</p>
          <p style="text-indent: 2em">
            本次采购公告在辉县市农村综合产权交易中心官网http://117.159.15.238:16035/上发布。
          </p>
          <p style="text-indent: 2em; font-weight: 600">九、联系方式</p>
          <p style="text-indent: 2em">采购人：{{ projectDetail.needname }}</p>
          <p style="text-indent: 2em">地址：{{ projectDetail.address }}</p>
          <p style="text-indent: 2em">联系人：{{ projectDetail.realname }}</p>
          <p style="text-indent: 2em">
            联系电话：{{ realPhone || projectDetail.phone
            }}<img
              src="../assets/img/openEye.png"
              style="width: 30px; height: 30px; cursor: pointer"
              @click="checkShowPhone" />
          </p>
          <p style="text-indent: 2em">组织机构：辉县市农村综合产权交易中心</p>
          <p style="text-indent: 2em">地址：辉县市政务服务大厅二楼南侧</p>
          <p style="text-indent: 2em">联系人：张老师 /朱老师</p>
          <p style="text-indent: 2em">联系电话：0373-6053001 / 0373-6053002</p>
          <p style="text-indent: 2em; text-align: right">
            辉县市农村综合产权交易中心
          </p>
          <p style="text-indent: 2em; text-align: right">
            {{ formatDate(projectDetail.createTime) }}
          </p>
        </div>
        <!-- <div
          class="hetongBox"
          v-else-if="getNeedPorjectType(projectDetail.number) == '服务类'"
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.projectname }}项目交易公告
          </p>
          <p style="text-indent: 2em">
            根据《中华人民共和国民法典》《中华人民共和国农村土地承包法》《中华人民共和国土地管理法》等法律法规，本着平等、自愿、公平、诚信、有偿的原则，经甲乙双方协商一致，签订本合同。
          </p>
          <p style="text-indent: 2em; font-weight: 700">一、当事人</p>
          <p style="text-indent: 2em">
            甲方(出租方):<span style="text-decoration: underline">{{
              projectDetail.outname
            }}</span>
          </p>
          <p style="text-indent: 2em">
            社会信用代码:___________________________________
          </p>
          <p style="text-indent: 2em">
            法定代表人(负责人):___________________________________
          </p>
          <p style="text-indent: 2em">
            身份证号码:<span style="text-decoration: underline">{{
              projectDetail.idnum
            }}</span>
          </p>
          <p style="text-indent: 2em">
            联系电话:<span style="text-decoration: underline">{{
              realPhone ||projectDetail.phone
            }}</span><img
                    src="../assets/img/openEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    @click="checkShowPhone"
                  />
          </p>
          <p style="text-indent: 2em">
            乙方(承租方):___________________________________
          </p>
          <p style="text-indent: 2em">
            社会信用代码:___________________________________
          </p>
          <p style="text-indent: 2em">
            法定代表人(负责人/农户代表人):___________________________________
          </p>
          <p style="text-indent: 2em">
            身份证号码:___________________________________
          </p>
          <p style="text-indent: 2em">
            联系地址:___________________________________
          </p>
          <p style="text-indent: 2em">
            联系电话:___________________________________
          </p>
          <p style="text-indent: 2em; font-weight: 700">二、房屋基本状况</p>
          <p style="text-indent: 2em">
            位置:<span style="text-decoration: underline">{{
              projectDetail.pid
            }}</span
            >(东至：<span style="text-decoration: underline">{{
              projectDetail.east
            }}</span
            >，西至：<span style="text-decoration: underline">{{
              projectDetail.west
            }}</span
            >，南至：<span style="text-decoration: underline">{{
              projectDetail.south
            }}</span
            >，北至：<span style="text-decoration: underline">{{
              projectDetail.north
            }}</span
            >。)
          </p>
          <p style="text-indent: 2em">
            面积:建筑面积____________平方米，层数_____。
          </p>
          <p style="text-indent: 2em">附属物:见房屋交付清单(附照片)</p>
          <p style="text-indent: 2em; font-weight: 700">三、租赁用途</p>
          <p style="text-indent: 2em">
            租赁房屋用途为:________(居住、经营、库房、小作坊、商铺等)
          </p>
          <p style="text-indent: 2em; font-weight: 700">四、租赁期限</p>
          <p style="text-indent: 2em">
            (一)房屋租赁期自<span style="text-decoration: underline">{{
              formatDate(projectDetail.needstarttime)
            }}</span
            >起至<span style="text-decoration: underline">{{
              formatDate(projectDetail.needstoptime)
            }}</span
            >止。
          </p>
          <p style="text-indent: 2em">
            (二)甲方应于_____年____月____日前将房屋交付给乙方。经甲乙双方交验签字或盖章并移交房屋后视为交付完成
          </p>
          <p style="text-indent: 2em">
            (三)租赁期满或合同解除后，甲方有权收回房屋，乙方应返还房屋及其附属物品、设备设施。甲乙双方应对房屋和附属物品、设备设施及水电等使用情况进行验收，结清各自应当承担的费用。
          </p>
          <p style="text-indent: 2em; font-weight: 700">五、租金及押金</p>
          <p style="text-indent: 2em">
            (一)租金支付:□ 季度、□ 半年付、□ 年付、□ 一次性付清、□
            其他，人民币_________元(大写________________元)。乙方须提前15日支付后一期租金。
          </p>
          <p style="text-indent: 2em">
            (二)房屋押金________元(_____个月，________元)，于合同签订后_______日内交纳完毕，待合同期满或特殊情况导致合同结束，乙方退租后返还。如出现设备设施损坏的现象，甲方有权按照市场价格扣除相应的赔偿款。
          </p>
          <p style="text-indent: 2em">
            (三)支付方式:租金及押金由乙方以转账方式缴交。
          </p>
          <p style="text-indent: 2em">
            甲方账户名称:<span style="text-decoration: underline">{{
              backCardInfo && backCardInfo.cardName
            }}</span>
          </p>
          <p style="text-indent: 2em">
            银行账号:<span style="text-decoration: underline">{{
              backCardInfo && backCardInfo.cardNo
            }}</span>
          </p>
          <p style="text-indent: 2em">
            开户银行:<span style="text-decoration: underline">{{
              backCardInfo && backCardInfo.bankName
            }}</span>
          </p>
          <p style="text-indent: 2em">
            (四)租金变动:根据双方约定，每______年调整一次租金。具体调整方式:____________________________
          </p>
          <p style="text-indent: 2em; font-weight: 700">六、房屋维护及维修</p>
          <p style="text-indent: 2em">
            租赁期内，甲乙双方应共同保障房屋及其附属物品、设备设施处于适用和安全的状态:
          </p>
          <p style="text-indent: 2em">
            1.对于房屋及其附属物品、设备设施因自然属性或合理使用而导致的损耗，乙方应及时通知甲方修复。甲方应在接到乙方通知后进行维修。
          </p>
          <p style="text-indent: 2em">
            2.因乙方保管不当或不合理使用，致使房屋及其附属物品、设备设施发生损坏或故障的，乙方应负责维修或承担赔偿责任。
          </p>
          <p style="text-indent: 2em; font-weight: 700">七、转租</p>
          <p style="text-indent: 2em">
            除甲乙双方另有约定以外，乙方需事先征得甲方书面同意，方可转租给他人，并就受转租人的行为向甲方承担责任。
          </p>
          <p style="text-indent: 2em; font-weight: 700">八、合同解除</p>
          <p style="text-indent: 2em">
            (一)经甲乙双方协商一致，可以解除本合同。
          </p>
          <p style="text-indent: 2em">
            (二)合同到期或因不可抗力导致本合同无法继续履行的，本合同自行解除。
          </p>
          <p style="text-indent: 2em">
            (三)未经甲方同意，乙方私自改变用途或非法他用，本合同自行解除。
          </p>
          <p style="text-indent: 2em">
            (四)乙方没有如期支付租金的，甲方有权单方面解除合同。
          </p>
          <p style="text-indent: 2em; font-weight: 700">九、其他约定</p>
          <p style="text-indent: 2em">
            (一)如中途国家或政府需要拆迁征用此房屋，甲方需提前_____个月通知乙方，乙方必须在______个月内把房屋腾空，并无条件搬迁，甲方负责退还未到期租金及押金。
          </p>
          <p style="text-indent: 2em">
            (二)本房屋所产生的债权债务及其他纠纷与乙方无关，若有纠纷使乙方不能正常使用而造成损失的，由甲方负责赔偿。赔偿标准为__________。若不能正常使用时间达到_______个月的，双方协商解除合同。
          </p>
          <p style="text-indent: 2em">
            (三)安全责任。甲方就房屋现状交付乙方使用。乙方在使用过程中应确保房屋建筑结构安全可靠。如发现房屋有建筑、消防安全隐患，应及时通知甲方。乙方在房屋租赁期间相关安全责任自行承担。
          </p>
          <p style="text-indent: 2em">
            (四)房屋装修。乙方在征得甲方同意下，可对所租房屋进行装修，但不得改变所租房屋承重墙体。合同终止时对所租房屋装修形成的不可移动的添附物如需恢复原状，乙方应根据甲方要求恢复原状;如无需恢复原状，乙方应无偿留给甲方。
          </p>
          <p style="text-indent: 2em">
            (五)乙方保证承租甲方房屋用途合法，自觉遵守公共秩序，不得影响他人和社会秩序，遵守相关法律规定。因乙方违规违法而造成的一切法律责任和财产损失，均由乙方自行承担。
          </p>
          <p style="text-indent: 2em">
            (六)乙方负责支付出租房屋的房屋租赁税、水费、电费、燃气费、电话费、光缆电视收视费、宽带费、卫生费和物业管理费等全部费用。
          </p>
          <p style="text-indent: 2em">
            (七)乙方保证，在租赁期内未征得甲方书面同意以及按规定经有关部门审核批准前，不得擅自改变该房屋的用途。
          </p>
          <p style="text-indent: 2em">
            (八)未经甲方同意，不得在租赁房屋上设置任何第三方权利。
          </p>
          <p style="text-indent: 2em; font-weight: 700">十、违约金和违约责任</p>
          <p style="text-indent: 2em">
            (一)若甲方在乙方没有违反本合同的情况下提前解除合同或租给他人，视为甲方违约，应按月租金的_____%，向乙方支付违约金。
          </p>
          <p style="text-indent: 2em">
            (二)若乙方在甲方没有违反本合同的情况下提前解除合同，视为乙方违约，退还剩余租期内租金但押金不予退还，同时应按月租金的______%，向甲方支付违约金。
          </p>
          <p style="text-indent: 2em">
            (三)乙方逾期交付租金，除应及时如数补交外，还需支付滞纳金，滞纳金按照每逾期一日，应付未付金额的________计算，滞纳金甲方有权直接从乙方交纳的押金中扣除;乙方逾期交纳租金超过_________日，甲方有权单方解除本合同。
          </p>
          <p style="text-indent: 2em">
            (四)乙方未按照合同约定返还房屋的，占用期间按照______元/天支付租金;超过_______日，甲方有权单方收回房屋，保管乙方屋内物品，保管费用按照________元/天计算;不可移动物或不易保管物品视为乙方放弃所有权，由甲方自行处理。
          </p>
          <p style="text-indent: 2em">
            (五)本合同生效之后，如任何一方违约，守约方为维护权益，向违约方追偿一切费用(包括但不限于律师费、诉讼费、保全费、鉴定费、差旅费等费用)。
          </p>
          <p style="text-indent: 2em; font-weight: 700">十一、争议处理方式</p>
          <p style="text-indent: 2em">
            本合同在履行过程中如发生纠纷，甲乙双方可以协商解决，也可以直接向房屋所在地人民法院起诉。
          </p>
          <p style="text-indent: 2em; font-weight: 700">十二、附则</p>
          <p style="text-indent: 2em">
            (一)本合同未尽事宜，经甲方、乙方协商一致后可签订补充协议。补充协议与本合同具有同等法律效力。
          </p>
          <p style="text-indent: 2em">
            补充条款(可另附件):________________________
          </p>
          <p style="text-indent: 2em">
            (二)本合同自甲乙双方签字、盖章或者按指印之日起生效。本合同一式四份，由甲方、乙方、乡镇人民政府、获嘉县农村产权交易中心各执一份。
          </p>
          <p style="text-indent: 2em">
            甲方:____________________乙方:_________________
          </p>
          <p style="text-indent: 2em">
            法定代表人(负责人)_____ 法定代表人(负责人)
          </p>
          <p style="text-indent: 2em">
            签字:____________________签字:____________________
          </p>
          <p style="text-indent: 2em">
            签订时间:_____年_____月______日 签订时间:_____年_____月______日
          </p>
          <p style="text-indent: 2em">
            签订地点:{{ cityDetail.cityName }}公共资源交易中心
          </p>
          <p style="text-indent: 2em">附件</p>
          <p style="text-align: center; font-size: 26px">房屋交付清单</p>
          <table border="1" style="width: 800px; margin: 0 auto">
            <tr>
              <th style="text-align: center">序号</th>
              <th style="text-align: center">附件名称</th>
              <th style="text-align: center">页数</th>
              <th style="text-align: center">备注</th>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: center">
                共计______份， 页。
              </td>
            </tr>
          </table>
        </div>
        <div class="hetongBox" v-else>
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ projectDetail.projectname }}项目交易公告
          </p>
          <br />
          <p style="text-indent: 2em">
            根据采购人申请，定于{{
              formatDate(timeDetail.biddingStartTime)
            }}在辉县市农村综合产权交易中心http://117.159.15.238:16035/网络竞价平台对{{
              projectDetail.projectname
            }}项目进行公开竞价（反向）采购，现将采购事项公告如下。
          </p>
          <p style="text-indent: 2em; font-weight: 600">一、项目基本情况</p>
          <p style="text-indent: 2em">
            1.项目编号：{{ projectDetail.numbering }}
          </p>
          <p style="text-indent: 2em">
            2.项目名称：{{ projectDetail.projectname }}
          </p>
          <p style="text-indent: 2em">3.交易方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            4.预算总额：{{ projectDetail.price }}元（最高限价）
          </p>
          <p style="text-indent: 2em">
            5.项目地址：{{ projectDetail.areaName }}
          </p>
          <p style="text-indent: 2em">6.标段划分：本项目共划分为一个标段</p>
          <p style="text-indent: 2em">7.质量标准：合格，达到国家质量验收标准</p>
          <p style="text-indent: 2em">8.合同期限：合同签订后7日历日</p>
          <p style="text-indent: 2em">9.资金来源：自筹资金</p>
          <p style="text-indent: 2em">
            10.付款方式：双方根据合同约定付款方式进行付款。
          </p>
          <p style="text-indent: 2em">11.履约保证金：无</p>
          <p style="text-indent: 2em">12.项目是否接受联合体：否</p>
          <p style="text-indent: 2em">
            13.标的应具备条件：工程质量要求符合国家相关施工验收规范，达到合格标准。
          </p>
          <p style="text-indent: 2em; font-weight: 600">二、投标人的资格要求</p>
          <p style="text-indent: 2em">
            1.需具有有效的资格证书，有相应的经营范围。
          </p>
          <p style="text-indent: 2em">2.具有独立承担民事责任的能力。</p>
          <p style="text-indent: 2em">3.具有良好的商业信誉。</p>
          <p style="text-indent: 2em">
            4.具有履行合同所必需的设备和专业技术能力。
          </p>
          <p style="text-indent: 2em">5.有依法缴纳税收的良好记录。</p>
          <p style="text-indent: 2em">
            6.信誉要求：列入失信被执行人、重大税收违法失信主体、政府采购严重违法失信行为记录名单的投标人，将拒绝参与本次交易活动。
          </p>
          <p style="text-indent: 2em">
            【查询渠道：1.“信用中国”网站www.creditchina.gov.cn查询内容:重大税收违法失信主体；2.“中国执行信息公开网”网站http://zxgk.court.gov.cn查询内容为：失信被执行人；3.中国政府采购网www.ccgp.gov.cn查询内容为：政府采购严重违法失信行为记录名单】。
          </p>
          <p style="text-indent: 2em; font-weight: 600">三、报名方式</p>
          <p style="text-indent: 2em">
            1.报名截止时间：{{ formatDate(timeDetail.applyStopTime) }}。
          </p>
          <p style="text-indent: 2em">2.报名注意事项：</p>
          <p style="text-indent: 2em">
            2.1意向投标人须在{{
              formatDate(timeDetail.applyStopTime)
            }}前登录辉县市农村综合产权交易中心官网http://117.159.15.238:16035/#/，按要求进行实名注册及报名。
          </p>
          <p style="text-indent: 2em">
            2.2意向供应商需在{{
              formatDate(timeDetail.applyStopTime)
            }}前按要求上传相关资料进行资格审核。
          </p>
          <p style="text-indent: 2em; font-weight: 600">四、保证金</p>
          <p style="text-indent: 2em">
            1.保证金金额：{{ projectDetail.bailAmount }}元人民币（大写：人民币{{
              bigWrite(projectDetail.bailAmount)
            }}元整）。
          </p>
          <p style="text-indent: 2em">
            2.保证金到账截止时间：{{
              formatDate(timeDetail.applyStopTime)
            }}（北京时间）。
          </p>
          <p style="text-indent: 2em">
            3.保证金交纳请联系：18236953278/13753689950
          </p>
          <p style="text-indent: 2em">
            注：保证金未在规定时间到账、未交纳到指定账号或无效交纳的，该意向投标人不能参与竞价。汇款时请注明该笔费用为保证金，并备注项目名称或项目编号（须为投标人账户汇出）。
          </p>
          <p style="text-indent: 2em; font-weight: 600">五、公开竞价</p>
          <p style="text-indent: 2em">
            1.竞价开始时间：{{
              formatDate(timeDetail.biddingStartTime)
            }}（北京时间）。
          </p>
          <p style="text-indent: 2em">2.竞价方式：网络竞价（反向）</p>
          <p style="text-indent: 2em">
            3.自由竞价时间：{{ formatDate(timeDetail.biddingStartTime) }}至{{
              formatDate(timeDetail.biddingStopTime)
            }}。
          </p>
          <p style="text-indent: 2em">
            注：投标人在竞价开始10分钟前登录系统并进入竞价大厅，遇见技术问题请及时与我中心联系沟通解决。
          </p>
          <p style="text-indent: 2em; font-weight: 600">六、确定成交供应商</p>
          <p style="text-indent: 2em">1.投标人按照报价最低原则确定成交人。</p>
          <p style="text-indent: 2em">
            2.报价最低的投标人放弃成交的，其交纳的保证金不予退还并作为违约金由农交中心予以没收。对意向投标人失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">七、声明</p>
          <p style="text-indent: 2em">
            进入网络竞价环节且出价的意向投标人即视为完全同意并响应采购公告、采购文件的全部内容，成交之后不得再以此为由提出任何异议。成交投标人所供的标的及服务（工程服务）必须实质性满足交易公告、交易文件的全部需求，若不满足上述要求，其保证金将不予退还并作为违约金由农交中心予以没收。意向投标人所提供的标的及服务（工程服务）若未按交易公告、交易文件要求或未完全满足交易公告、交易文件要求的，将会列入农交中心诚信评价体系。对意向投标人失信行为的惩戒措施按相关法律法规及辉县市农村综合产权交易中心的相关规定执行。
          </p>
          <p style="text-indent: 2em; font-weight: 600">八、发布公告的媒介</p>
          <p style="text-indent: 2em">
            本次交易公告在辉县市农村综合产权交易中心官网http://117.159.15.238:16035/#/上发布。
          </p>
          <p style="text-indent: 2em; font-weight: 600">九、联系方式</p>
          <p style="text-indent: 2em">采购人：{{ projectDetail.needname }}</p>
          <p style="text-indent: 2em">地址：{{ projectDetail.address }}</p>
          <p style="text-indent: 2em">联系人：{{ projectDetail.realname }}</p>
          <p style="text-indent: 2em">联系电话：{{ realPhone ||projectDetail.phone }}<img
                    src="../assets/img/openEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    @click="checkShowPhone"
                  /></p>
          <p style="text-indent: 2em">组织机构：辉县市农村综合产权交易中心</p>
          <p style="text-indent: 2em">地址：辉县市政务服务大厅二楼南侧</p>
          <p style="text-indent: 2em">联系人：张老师 /朱老师</p>
          <p style="text-indent: 2em">联系电话：0373-6053001 / 0373-6053002</p>
          <p style="text-indent: 2em; text-align: right">
            辉县市农村综合产权交易中心
          </p>
          <p style="text-indent: 2em; text-align: right">
            {{ formatDate(projectDetail.createTime) }}
          </p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getPhoneById } from '../api/login'
import { getNewsDetail, getNewslist } from '../api/mian'
import { getProList } from '../api/交易项目'
import { getInfoByDeptId, getTypeList } from '../api/交易项目详情'
import { cityDetail } from '../util/mainOption'

export default {
  props: {
    projectDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    dicts: {
      type: Object,
      default: () => {
        return {}
      },
    },
    backCardInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    timeDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 当前地级名称
      deptName: '',
      // 查看区域下标
      getDetailActive: '1',
      // 小分类列表
      classTypeList: [],
      // 报名方式 html
      applyWay: '',
      // 报名须知 html
      bmxzContent: '',
      // 竞拍须知 html
      jpxzContent: '',
      // 需求项目类型列表
      needProjectTypeList: [],
      // 字典列表
      dictList: {
        // 转出方式
        out_type: [],
      },
      realPhone: '',
    }
  },
  mounted() {
    for (let dictTitle of Object.keys(this.dictList)) {
      getTypeList(dictTitle).then((res) => {
        this.dictList[dictTitle] = res.data.data
      })
    }
    getProList({ type: 3 }).then((res) => {
      this.needProjectTypeList = res.data.data
    })
    this.deptName = localStorage.getItem('deptName')
      ? localStorage.getItem('deptName')
      : this.cityDetail.cityName
    getNewslist({
      number: '021',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then((res) => {
      res.data.rows.length > 0 &&
        getNewsDetail({ id: res.data.rows[0].id }).then((res) => {
          this.applyWay = res.data.data.content
        })
    })
    getNewslist({
      number: '022',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then((res) => {
      res.data.rows.length > 0 &&
        getNewsDetail({ id: res.data.rows[0].id }).then((res) => {
          this.bmxzContent = res.data.data.content
          console.log('报名须知新闻详情', this.bmxzContent)
        })
    })
    getNewslist({
      number: '023',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then((res) => {
      res.data.rows.length > 0 &&
        getNewsDetail({ id: res.data.rows[0].id }).then((res) => {
          this.jpxzContent = res.data.data.content
          console.log('竞拍须知新闻详情', this.jpxzContent)
        })
    })
    getProList({ type: 3 }).then((res) => {
      // console.log('已打印')
      this.classTypeList = res.data.data
    })
  },
  methods: {
    // 获取字典值
    getDictValue(value, dictTitle) {
      if (value !== 0 && value !== '0' && !value) return '暂无'
      return this.dictList[dictTitle].find((item) => item.dictValue == value)
        ? this.dictList[dictTitle].find((item) => item.dictValue == value)
            .dictLabel
        : '暂无'
    },
    bigWrite(num) {
      let max = 999999999999.99
      if (Number(num) > max) return '超过函数可接受最大值'
      if (!Number(num)) return '零元'
      let unitList = ['', '拾', '佰', '仟']
      let numberList = [
        '零',
        '壹',
        '贰',
        '叁',
        '肆',
        '伍',
        '陆',
        '柒',
        '捌',
        '玖',
      ]
      let decimals = num.toString().split('.')[1]
      num = num.toString().split('.')[0]
      let numToStringRes = ''
      let numSliceList = console.log('num.length', num.length)
      if (num.length > 8) {
        numSliceList = {
          亿: '',
          万: '',
          元: '',
        }
        numSliceList['亿'] = num.slice(0, num.length - 8)
        numSliceList['万'] = num.slice(num.length - 8, num.length - 4)
        numSliceList['元'] = num.slice(num.length - 4)
      } else if (num.length > 4) {
        numSliceList = {
          万: '',
          元: '',
        }
        numSliceList['万'] = num.slice(0, num.length - 4)
        numSliceList['元'] = num.slice(num.length - 4)
      } else {
        numSliceList = {
          元: '',
        }
        numSliceList['元'] = num
      }
      for (let j = 0; j < Object.keys(numSliceList).length; j++) {
        num = Number(numSliceList[Object.keys(numSliceList)[j]])
        let stringRes = ''
        for (let i = 0; i < unitList.length; i++) {
          if (num == 0) {
            break
          }
          let yu = Math.floor(num % 10)
          stringRes =
            (numberList[yu] == '零'
              ? numberList[yu]
              : numberList[yu] + unitList[i]) + stringRes
          num = Math.floor(num / 10)
        }
        while (true) {
          if (stringRes.indexOf('零零') < 0) {
            break
          }

          stringRes = stringRes.replace('零零', '零')
        }
        if (stringRes.slice(stringRes.length - 1) == '零') {
          stringRes = stringRes.substring(0, stringRes.length - 1)
        }
        stringRes += Object.keys(numSliceList)[j]
        numToStringRes += stringRes
      }
      if (decimals.length > 0 && Number(decimals) != 0) {
        decimals = Number(decimals)
        numToStringRes +=
          (numberList[Math.floor(decimals / 10)]
            ? numberList[Math.floor(decimals / 10)] + '角'
            : '零') +
          (numberList[Math.floor(Number(decimals % 10))] == '零'
            ? numberList[Math.floor(Number(decimals % 10))] + '分'
            : '')
      }
      while (true) {
        if (numToStringRes.indexOf('壹拾') < 0) {
          break
        }
        numToStringRes = numToStringRes.replace('壹拾', '拾')
      }

      return numToStringRes
    },
    formatDate(cellValue) {
      if (cellValue == null || cellValue == '') return ''
      var date = new Date(cellValue)
      var year = date.getFullYear()
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return (
        year + '年' + month + '月' + day + '日' + hours + '时' + minutes + '分'
      )
    },
    getNeedPorjectType(num) {
      let typeObj = this.needProjectTypeList.find((item) => item.code == num)
      return typeObj ? typeObj.name : ''
    },
    getYearLimit() {
      let start = new Date(this.projectDetail.needstarttime)
      let stop = new Date(this.projectDetail.needstoptime)
      return (
        (Number(stop.getTime()) - Number(start.getTime())) /
        (1000 * 60 * 60 * 24 * 30 * 12)
      ).toFixed(1)
    },
    // 获取小分类列表
    getClassList(list, id) {
      return list.filter((item) => {
        return item.code == id
      })[0]
        ? list.filter((item) => {
            return item.code == id
          })[0].name
        : ''
    },
    // 手机号小眼睛点击事件
    checkShowPhone() {
      if (this.realPhone) return
      if (!localStorage.getItem('token')) {
        this.$message.warning('请登录后查看！')
        return
      }
      getPhoneById({
        id: this.projectDetail.id,
        projectType: 3,
      }).then((res) => {
        if (res.data.code == 200) {
          this.realPhone = res.data.msg
        }
      })
    },
    // 获取字典内容方法
    getDictsVal(list, val) {
      if (!!list && !!val) {
        return list.filter((item) => {
          return item.dictValue == val
        })[0]
          ? list.filter((item) => {
              return item.dictValue == val
            })[0].dictLabel
          : ''
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}
.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
  cursor: pointer;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
  cursor: pointer;
}
.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}

.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
}

.tet2 {
  padding: 20px 20px;
  width: 550px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100%; */
}

.money {
  display: flex;
  flex-direction: column;
}

.moneyTableTitle {
  display: flex;
  align-content: center;
}

.mtt {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
  font-weight: 600;
  background-color: #f3f5f8;
}

.mtc {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
}

.list {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #606266;
  padding: 10px 0;
  border-bottom: 1px solid #606266;
  display: flex;
  justify-content: space-between;
}

.list:last-child {
  border-bottom: 0;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}

.input-number {
  /* transform: scale(1.25); */
  width: 200px;
}

.input-number >>> .el-input__inner {
  width: 200px;
  text-align: right;
  font-size: 24px !important;
  font-weight: bold !important;
}
.conent > div {
  margin: 10px 0;
}
.fengexian {
  margin-bottom: 40px;
  /deep/ .el-divider__text {
    font-size: 36px;
    /* margin-bottom: 40px; */
    color: #f56c6c;
    list-style: armenian;
  }
}

.fengexian1 {
  margin: 30px 0 50px 0;
  /deep/ .el-divider__text {
    font-size: 36px;
    /* margin-bottom: 40px; */
    color: #f56c6c;
    list-style: armenian;
  }
}
.hetongBox {
  width: 100%;
  height: auto;
  text-align: start;
  p {
    line-height: 2;
  }
}
</style>
